import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";
import axiosInstance from "pages/Utility/axiosInstance";
import { showSuccess } from "helpers/notification_helper";
import Cookies from "js-cookie";
import { FaTimesCircle, FaCheckCircle } from "react-icons/fa";


const SiteSurveyCancellationTable = ({ List, fetchCancellationOrders }) => {

  const userId = JSON.parse(Cookies.get('authUser'))?.userId
  // Table columns definition
  const columns = useMemo(
    () => [
      {
        header: 'Site Survey Number',
        accessorKey: 'siteSurveyNumber',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Requested By',
        accessorKey: 'requestedBy',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Requested On',
        accessorKey: 'requestedOn',
        enableColumnFilter: false,
        enableSorting: true,
        cell:({row})=>(
          <span>
            {formatDateTimeToAmPm(row.original?.requestedOn)}
          </span>
        )
      },
      {
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {
          const handleApprove = async() => {
            try {
              const response = await axiosInstance.post('',{
                "sp": "usp_ApproveSitesurveyCancellation",
               "cancellationHistoryId": row.original?.cancellationHistoryId,
                "updatedBy": userId,
                "reason":"",
            })
            if(response){
              showSuccess("Cancellation request is Approved ")
              fetchCancellationOrders()
            }
            } catch (error) {
              
            }
          };

          const handleDelete = async() => {
            try {
              const response = await axiosInstance.post('',{
                "sp": "usp_RejectSitesurveyCancellation",
                "cancellationHistoryId": row.original?.cancellationHistoryId,
                "updatedBy": userId
            })
            if(response){
              showSuccess("Cancellation request is rejected ")
              fetchCancellationOrders()
            }
            } catch (error) {
              
            }
           
          };

          return (
            <div className="d-flex gap-2">
              <Button color="primary" title="Approve" onClick={handleApprove} className="mr-2 d-flex align-items-center">
                <FaCheckCircle size={18} />
              </Button>
              <Button color="danger" title="Reject" onClick={handleDelete} className="mr-2 d-flex align-items-center">
                <FaTimesCircle size={18} />
              </Button>
            </div>
          );
        },
      },
    ],
    [List]
  );

  // Meta title
  document.title = "Site Survey Cancellation Management | Admin Dashboard";

  return (
    <>
      <div className="">
        <div className="container-fluid">
          <TableContainer
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Site Survey Cancellation Details"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default SiteSurveyCancellationTable;
